import React, {useEffect, useState} from "react";
import {Avatar, Badge, Button, Col, Divider, Drawer, Layout, Popover, Row, Space} from "antd";
import {useRecoilState, useRecoilValue} from "recoil";
import {
    globalBrandSettingState,
    globalColorThemeState,
    globalOpenGoLiveModalState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState,
    globalUserDetailState,
} from "../../../../_common/global_state";
import {DownOutlined} from "@ant-design/icons";
import QrModal from "../qr/qrModal";
import {useIsMobile} from "../../../../_common/function";
import PlatformDownloadModal from "../platformDownload/platformDownloadModal";
import {getPlatform} from "../../../../api/graphql/platformDownload";
import dummyImg from "../../../../assets/image/dummy.png";
import {useNavigate} from "react-router-dom";
import useShared from "../../../../_common/_shared";
import {useTranslation} from "react-i18next";
import GoLiveModal from "../goLive";
import {useVerification} from "../../../../_common/_authorize";
import useLayoutFunction, {formatMobileHeaderRoutes} from "../../../function";
import FooterTime from "../latestTime/footerTime";
import {getUserAnnouncementUnreadCount} from "../../../../api/graphql/announcement";
import Announcement_1 from "../../../../pages/announcement/view/layout_1";
import PopoverContentConfig from "./component/popoverContentConfig";
import PopoverContent from "./component/popoverContent";

const {Header} = Layout;

export const Header_1 = (props) => {
    const {registerField, headerRoutes, mobileRoutes} = props;
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isMobile = useIsMobile(768);
    const {IconCommon, IconModule} = useShared();
    const {filterAndGroupServers} = useLayoutFunction();
    const {baseErrorChecking} = useVerification();

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [openQrModal, setOpenQrModal] = useState(false);
    const [openPlatformModal, setOpenPlatformModal] = useState(false);
    const [platformData, setPlatformData] = useState([]);
    const [open, setOpen] = useState(false);
    const [popoverContentConfigKey, setPopoverContentConfigKey] = useState(null);

    const userDetails = useRecoilValue(globalUserDetailState);
    const brandSettingState = useRecoilValue(globalBrandSettingState);
    const colorState = useRecoilValue(globalColorThemeState);
    const [openGoLiveModal, setOpenGoLiveModal] = useRecoilState(globalOpenGoLiveModalState);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);

    const userId = localStorage.getItem("userid")

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const preload = async () => {
        try {
            const res = await getUserAnnouncementUnreadCount(userId);

            if (res?.getUserAnnouncementByUserId?.__typename === "BaseError") {
                return await baseErrorChecking(res?.getUserAnnouncementByUserId?.errKey)
            }

            setUnreadAnnouncementCount(res?.getUserAnnouncementByUserId?.unreadTotal)

            const response = await getPlatform();

            if (response?.getPlatform?.__typename === "BaseError") {
                return await baseErrorChecking(response?.getPlatform?.errKey)
            }

            const filtered = filterAndGroupServers(response?.getPlatform?.data);
            setPlatformData(filtered);
        } catch (e) {
            console.error(e)
        }
    };

    useEffect(() => {
        preload();
    }, []);

    const platformDownloadKey = platformData ? Object.entries(platformData) : [];

    const mobileHeaderRoutes = formatMobileHeaderRoutes(mobileRoutes);

    return (
        <Header id={"layout-header"}>
            {isMobile ? (
                <Row justify={"space-between"} align={"middle"} wrap={false}>
                    <Col>
                        <img
                            alt={""}
                            className={"clickable"}
                            onClick={() => navigate("/dashboard")}
                            height={30}
                            src={colorState === "dark" ? brandSettingState?.siteFaviconInverse : brandSettingState?.siteFavicon}
                        />
                    </Col>
                    <Space>
                        <Popover
                            placement={"bottom"}
                            trigger={"click"}
                            content={<Announcement_1 isHeader/>}
                            getPopupContainer={() => document.querySelector("#layout-1")}
                        >
                            <div className={"header-announcement"}>
                                <Badge count={unreadAnnouncementCount + unreadPushNotificationCount} size={"small"}>
                                    <IconCommon iconName={"cm-notification-regular"}/>
                                </Badge>
                            </div>
                        </Popover>
                        <IconCommon
                            onClick={onOpen}
                            iconName={"cm-hamburger-regular"}
                            className={"header-icon"}
                        />
                    </Space>
                    <Drawer
                        className={"header-drawer"}
                        getContainer={() => document.querySelector("#layout-1")}
                        title={
                            <Row
                                className={"header-drawer-title"}
                                justify={"space-between"}
                                align={"middle"}
                                wrap={false}
                            >
                                <Col>
                                    <img
                                        alt={""}
                                        className={"clickable"}
                                        onClick={() => navigate("/dashboard")}
                                        height={30}
                                        src={colorState === "dark" ? brandSettingState?.siteFaviconInverse : brandSettingState?.siteFavicon}
                                    />
                                </Col>
                                <IconCommon
                                    onClick={() => setOpen(false)}
                                    iconName={"cm-close-regular"}
                                    className={"header-icon"}
                                />
                            </Row>
                        }
                        placement={"right"}
                        closable={false}
                        onClose={onClose}
                        open={open}
                        width={"100%"}
                    >
                        <Row justify={"space-between"} align={"top"}>
                            <div className={"avatar-section"}>
                                <Avatar
                                    className={"profile-avatar me-2"}
                                    size={48}
                                    src={userDetails?.profileImage || dummyImg}
                                />
                                <div>
                                    <div className={"username"}>
                                        {userDetails?.username}
                                    </div>
                                    <div className={"header-tag-container"}>
                                        <span className={"account-type-badge"}>{t(`user.statusTag.${userDetails?.clientAccountType}`)}</span>
                                        <span className={"rank-badge"}>{userDetails?.rank?.name}</span>
                                    </div>
                                </div>
                            </div>
                            <Popover
                                placement={"bottomRight"}
                                trigger={"click"}
                                content={
                                    <PopoverContentConfig
                                        platformDownloadKey={platformDownloadKey}
                                        setPopoverOpen={setPopoverOpen}
                                        setOpenQrModal={setOpenQrModal}
                                        platformData={platformData}
                                        popoverContentConfigKey={popoverContentConfigKey}
                                        setPopoverContentConfigKey={setPopoverContentConfigKey}
                                    />
                                }
                                getPopupContainer={() => document.querySelector("#layout-1")}
                                onOpenChange={(e) => {
                                    if (!e) setPopoverContentConfigKey(null);
                                }}
                            >
                                <div className={"header-config"}>
                                    <IconCommon iconName={"cm-setting-regular"}/>
                                </div>
                            </Popover>
                        </Row>
                        {userDetails?.clientAccountType !== "demo" ? (
                            <Button
                                className={"mt-3"}
                                type={"primary"}
                                block
                                onClick={() => setOpenGoLiveModal(true)}
                            >
                                {t("common.goLive")}
                            </Button>
                        ) : null}
                        <div className={"mt-3"}>
                            {Object.keys(mobileHeaderRoutes)?.map((item) => (
                                <div key={item} className={"mt-4"}>
                                    <p className={"drawer-section-title"}>{t(`common.${item}`)}</p>
                                    <Divider className={"mt-1 mb-3"}/>
                                    <Row gutter={[16, 16]}>
                                        {mobileHeaderRoutes[item]?.map((d) => (
                                            <Col
                                                span={8}
                                                key={d?.key}
                                                onClick={() => {
                                                    d?.type === "_blank" ? window.open(d?.path, "_blank") : navigate(d?.path);
                                                    setOpen(false);
                                                }}
                                            >
                                                {d?.icon}
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            ))}
                        </div>
                        <p className={"text-center mt-5"}>
                            <FooterTime/>
                        </p>
                    </Drawer>
                </Row>
            ) : (
                <Row justify={"space-between"} wrap={false}>
                    <Col>
                        <img
                            alt={""}
                            className={"clickable"}
                            onClick={() => navigate("/dashboard")}
                            style={{maxHeight: 40}}
                            src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                        />
                    </Col>
                    <div className={"header-link-section"}>
                        {headerRoutes.map((r) => (
                            <Popover
                                className={"header-link"}
                                key={r?.key}
                                destroyTooltipOnHide
                                trigger={"hover"}
                                content={!!r?.sub?.length && (
                                    <div className={"popover-select-item-list menu-dropdown"}>
                                        {r.sub.map((s) => (
                                            <Button
                                                type={"text"}
                                                className={"dropdown-link"}
                                                key={s?.key}
                                                onClick={() => {
                                                    if (s?.path?.startsWith("http")) {
                                                        window.open(s?.path, "_blank");
                                                        return;
                                                    }
                                                    navigate(s?.path);
                                                }}
                                            >
                                                <IconModule
                                                    iconName={`md-${s?.label?.replaceAll(".", "")?.replaceAll(" ", "")?.toLowerCase()}`}
                                                    layout={1}
                                                />
                                                {t(`module.${s?.label?.replaceAll(" ", "_")?.replaceAll(".", "")?.toLowerCase()}`)}
                                            </Button>
                                        ))}
                                    </div>
                                )}
                                getPopupContainer={() => document.querySelector("#layout-1")}
                            >
                                <div
                                    className={"header-nav-group"}
                                    onClick={() => {
                                        if (r?.path?.startsWith("http")) {
                                            window.open(r?.path, "_blank");
                                            return;
                                        }
                                        navigate(r?.path);
                                    }}
                                >
                                    <div>
                                        {t(`module.${r?.label?.replace(".", "")?.replace(/[-\s+]/g, "_").toLowerCase()}`)}
                                    </div>
                                    <div>{!!r?.sub?.length && <DownOutlined/>}</div>
                                </div>
                            </Popover>
                        ))}
                    </div>
                    <div className={"header-popover-section"}>
                        <Popover
                            trigger={"click"}
                            content={<PopoverContent setPopoverOpe={setPopoverOpen} setOpenQrModal={setOpenQrModal}/>}
                            open={popoverOpen}
                            onOpenChange={setPopoverOpen}
                            getPopupContainer={() => document.querySelector("#layout-1")}
                        >
                            <div className={"header-profile-section"}>
                                <div className={"header-avatar"}>
                                    <Avatar
                                        className={"profile-avatar"}
                                        size={34}
                                        src={userDetails?.profileImage || dummyImg}
                                    />
                                </div>
                                {userDetails.username}
                            </div>
                        </Popover>
                        <Popover
                            placement={"bottom"}
                            trigger={"click"}
                            content={<Announcement_1 isHeader/>}
                            getPopupContainer={() => document.querySelector("#layout-1")}
                        >
                            <div className={"header-announcement"}>
                                <Badge count={unreadAnnouncementCount + unreadPushNotificationCount} size={"small"}>
                                    <IconCommon iconName={"cm-notification-regular"}/>
                                </Badge>
                            </div>
                        </Popover>
                        <Popover
                            trigger={"click"}
                            content={
                                <PopoverContentConfig
                                    platformDownloadKey={platformDownloadKey}
                                    setPopoverOpen={setPopoverOpen}
                                    setOpenQrModal={setOpenQrModal}
                                    platformData={platformData}
                                    popoverContentConfigKey={popoverContentConfigKey}
                                    setPopoverContentConfigKey={setPopoverContentConfigKey}
                                />
                            }
                            getPopupContainer={() => document.querySelector("#layout-1")}
                            onOpenChange={(e) => {
                                if (!e) setPopoverContentConfigKey(null);
                            }}
                        >
                            <div className={"header-config"}>
                                <IconCommon iconName={"cm-setting-regular"}/>
                            </div>
                        </Popover>
                    </div>
                </Row>
            )}
            <QrModal
                isModalOpen={openQrModal}
                handleCancel={() => setOpenQrModal(false)}
                getPopupContainer={() => document.querySelector("#layout-1")}
            />
            <PlatformDownloadModal
                isModalOpen={openPlatformModal}
                handleCancel={() => setOpenPlatformModal(false)}
                platformData={platformData}
                getPopupContainer={() => document.querySelector("#layout-1")}
            />
            <GoLiveModal
                isModalOpen={openGoLiveModal}
                handleCancel={() => setOpenGoLiveModal(false)}
                registerField={registerField}
                getPopupContainer={() => document.querySelector("#layout-1")}
            />
        </Header>
    );
};
